module.exports = __webpack_public_path__ + "img/Thief.7248dca4.png";